import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { CookiesProvider } from 'react-cookie';
import store from '../store';

import AnalyticsProvider from '../components/analytics/AnalyticsProvider';

import SearchProvider from '../components/search/SearchProvider';
import Search from '../components/search/Search';
import { ToastProvider } from '@homeexchange/design';

const search = document.getElementById('search');
if (search) {
    createRoot(search).render(
        <CookiesProvider>
            <Provider store={store}>
                <ToastProvider>
                    <Router>
                        <AnalyticsProvider>
                            <SearchProvider>
                                <Search />
                            </SearchProvider>
                        </AnalyticsProvider>
                    </Router>
                </ToastProvider>
            </Provider>
        </CookiesProvider>
    );
}
